<script setup lang="ts">
import ServicesMobilityContent from "../components/ServicesMobilityContent.vue";
definePageMeta({
  layout: "services-layout",
});
</script>

<template>
  <ServicesMobilityContent />
</template>
